<template>
    <MediaDefault v-bind="props" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {MediaSlice} from '@prismicio-types';
    import MediaDefault from './MediaDefault.vue';

    type MediaImageLeftInZone = Extract<MediaSlice, {variation: 'mediaImageLeft'}>;
    const props = defineProps(getSliceComponentProps<MediaImageLeftInZone>());
</script>
